<template>
  <div class="ec-tabs-wrapper" :class="type ? 'ec-tabs-wrapper--' + type : ''">
    <div class="ec-tabs__nav">
      <div
        v-for="pane in panes"
        :key="pane.name"
        class="ec-tabs__tab"
        :class="{
          'ec-tabs__tab--active': value === pane.name,
          'ec-tabs__tab--disabled': pane.disabled,
        }"
        @click="!pane.disabled && $emit('input', pane.name)"
      >
        {{ pane.label }}
      </div>
    </div>
    <div class="ec-tabs__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EcTabs',

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: { type: String, default: '' },
    type: { type: String, default: '' },
  },

  data() {
    return {
      panes: [],
    }
  },

  methods: {
    addPane(pane) {
      if (!this.panes.find(function (p) { return p.name === pane.name })) {
        this.panes.push(pane)
        // Auto-activate first tab if nothing selected
        if (!this.value && this.panes.length === 1) {
          this.$emit('input', pane.name)
        }
      }
    },
    removePane(name) {
      var idx = this.panes.findIndex(function (p) { return p.name === name })
      if (idx > -1) this.panes.splice(idx, 1)
    },
  },
}
</script>

<style>
.ec-tabs-wrapper {
  width: 100%;
}

.ec-tabs__nav {
  display: flex;
  border-bottom: 2px solid var(--ec-border-color, #e2e8f0);
  margin-bottom: 16px;
  gap: 0;
  flex-wrap: wrap;
}

.ec-tabs__tab {
  padding: 10px 18px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  color: var(--ec-text-muted, #6b7280);
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s, border-color 0.15s;
  user-select: none;
  white-space: nowrap;
}

.ec-tabs__tab:hover:not(.ec-tabs__tab--disabled) {
  color: var(--ec-primary, #3b82f6);
}

.ec-tabs__tab--active {
  color: var(--ec-primary, #3b82f6);
  border-bottom-color: var(--ec-primary, #3b82f6);
}

.ec-tabs__tab--disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Card variant */
.ec-tabs-wrapper--card .ec-tabs__nav {
  border-bottom: 1px solid var(--ec-border-color, #e2e8f0);
}

.ec-tabs-wrapper--card .ec-tabs__tab {
  border: 1px solid transparent;
  border-radius: 4px 4px 0 0;
  margin-bottom: -1px;
}

.ec-tabs-wrapper--card .ec-tabs__tab--active {
  background: #fff;
  border-color: var(--ec-border-color, #e2e8f0);
  border-bottom-color: #fff;
  color: var(--ec-primary, #3b82f6);
}
</style>
